import React from 'react';
import './css/PartnerBenefits.css';

import Newsletter from './components/NewsLetter';
import Footer from './components/Footer';
import Navbar from './components/Navbar';

import PartnerBenefitsHeroBg from '../images/banner-partner.png';
import PartnerBenefitsDetailsImg from '../images/partnerRight.png';

import featureSectionBg2 from '../images/Banner3.png';

import {
    FaBullseye,
    FaHandshake,
    FaShieldAlt,
    FaHeart,
    FaUsers,
    FaUserCog,
    FaClipboardCheck,
    FaLaptopCode
} from "react-icons/fa";

import DownloadApp from './components/DownloadApp';

function PartnerBenefits() {

    return (
        <div className="PartnerBenefits-page-wrapper">

            {/* 1. Header Hero Section */}
            <section
                className="PartnerBenefits-hero-section"
                style={{ backgroundImage: `url(${PartnerBenefitsHeroBg})` }}
            >
                <Navbar />
            </section>


            {/* 2. Partner Introduction Section */}
            <section className="PartnerBenefits-details-section">
                <div className="container">

                    <div className="row align-items-center g-5">

                        {/* Left Column */}
                        <div className="col-lg-6">

                            <p className="info-small-text">
                                BECOME A FIXOVERA PARTNER
                            </p>

                            <h2 className="PartnerBenefits-section-heading">
                                Grow Your Service Business With Fixovera
                            </h2>

                            <div className="zigzag-divider mb-4"></div>

                            <p className="PartnerBenefits-body-text">
                                Fixovera helps skilled service professionals connect with
                                customers who are actively looking for reliable household
                                services.
                            </p>

                            <p className="PartnerBenefits-body-text highlighted-paragraph">
                                Whether you are a plumber, electrician, cleaner, carpenter,
                                painter, appliance technician, pest control professional,
                                or home service expert, Fixovera gives you a digital platform
                                to showcase your services, receive booking requests, manage
                                customers, and grow your business.
                            </p>

                            {/* Partner Metrics */}
                            <div className="row g-3 mt-4">

                                <div className="col-sm-4">
                                    <div className="metric-box box-blue">

                                        <h3 style={{ color: "#fff" }}>
                                            MORE
                                        </h3>

                                        <p
                                            style={{
                                                color: "#fff",
                                                fontSize: "11px"
                                            }}
                                        >
                                            Customer Opportunities
                                        </p>

                                    </div>
                                </div>


                                <div className="col-sm-4">
                                    <div className="metric-box box-yellow">

                                        <h3 style={{ color: "#fff" }}>
                                            EASY
                                        </h3>

                                        <p style={{ color: "#fff" }}>
                                            Booking Management
                                        </p>

                                    </div>
                                </div>


                                <div className="col-sm-4">
                                    <div className="metric-box box-teal">

                                        <h3 style={{ color: "#fff" }}>
                                            GROW
                                        </h3>

                                        <p
                                            style={{
                                                color: "#fff",
                                                fontSize: "11px"
                                            }}
                                        >
                                            Your Service Business
                                        </p>

                                    </div>
                                </div>

                            </div>

                        </div>


                        {/* Right Column */}
                        <div className="col-lg-6 text-center">

                            <img
                                src={PartnerBenefitsDetailsImg}
                                alt="Fixovera Service Partner"
                                className="img-fluid"
                                style={{
                                    border: "none",
                                    boxShadow: "none",
                                    outline: "none",
                                    borderRadius: 0,
                                    background: "transparent",
                                    display: "block",
                                    margin: "0 auto"
                                }}
                            />

                        </div>

                    </div>

                </div>
            </section>


            {/* 3. Partner Benefits Section */}
            <section
                className="PartnerBenefits-grid-bg-section"
                style={{ backgroundImage: `url(${featureSectionBg2})` }}
            >

                <div className="container">

                    {/* Section Header */}
                    <div className="row justify-content-center text-center mb-5">

                        <div className="col-lg-8">

                            <span className="grid-section-mini-tag">
                                WHY BECOME A PARTNER
                            </span>

                            <h2 className="grid-section-heading">
                                Benefits That Help Your Business Grow
                            </h2>

                            <p className="mt-3">
                                Join Fixovera and take your home service business
                                to the next level with better customer reach,
                                convenient booking management, and digital tools.
                            </p>

                            <div className="zigzag-border mx-auto mt-3"></div>

                        </div>

                    </div>


                    {/* Benefits Grid */}
                    <div className="row g-4 justify-content-center">


                        {/* More Customers */}
                        <div className="col-lg-6">

                            <div className="glass-grid-box">

                                <div className="grid-box-inner">

                                    <div className="grid-square-icon-wrapper accent-blue">
                                        <FaUsers className="grid-panel-icon" />
                                    </div>

                                    <div className="grid-box-text-block">

                                        <h4>Reach More Customers</h4>

                                        <p>
                                            Get discovered by customers looking for
                                            household services in your service area.
                                            Fixovera helps you expand your customer
                                            reach beyond your existing network.
                                        </p>

                                    </div>

                                </div>

                            </div>

                        </div>


                        {/* More Business Opportunities */}
                        <div className="col-lg-6">

                            <div className="glass-grid-box">

                                <div className="grid-box-inner">

                                    <div className="grid-square-icon-wrapper accent-yellow">
                                        <FaBullseye className="grid-panel-icon" />
                                    </div>

                                    <div className="grid-box-text-block">

                                        <h4>More Business Opportunities</h4>

                                        <p>
                                            Receive relevant service requests from
                                            customers and turn your professional
                                            skills into new business opportunities.
                                        </p>

                                    </div>

                                </div>

                            </div>

                        </div>


                        {/* Easy Booking Management */}
                        <div className="col-lg-6">

                            <div className="glass-grid-box">

                                <div className="grid-box-inner">

                                    <div className="grid-square-icon-wrapper accent-teal">
                                        <FaClipboardCheck className="grid-panel-icon" />
                                    </div>

                                    <div className="grid-box-text-block">

                                        <h4>Easy Booking Management</h4>

                                        <p>
                                            Manage customer booking requests,
                                            schedules, service details, and job
                                            updates through a convenient digital
                                            platform.
                                        </p>

                                    </div>

                                </div>

                            </div>

                        </div>


                        {/* Build Your Professional Profile */}
                        <div className="col-lg-6">

                            <div className="glass-grid-box">

                                <div className="grid-box-inner">

                                    <div className="grid-square-icon-wrapper accent-blue">
                                        <FaUserCog className="grid-panel-icon" />
                                    </div>

                                    <div className="grid-box-text-block">

                                        <h4>Build Your Professional Profile</h4>

                                        <p>
                                            Create a professional presence on Fixovera
                                            where customers can learn about your
                                            services, expertise, and service categories.
                                        </p>

                                    </div>

                                </div>

                            </div>

                        </div>


                        {/* Trusted Platform */}
                        <div className="col-lg-6">

                            <div className="glass-grid-box">

                                <div className="grid-box-inner">

                                    <div className="grid-square-icon-wrapper accent-yellow">
                                        <FaShieldAlt className="grid-panel-icon" />
                                    </div>

                                    <div className="grid-box-text-block">

                                        <h4>Be Part of a Trusted Platform</h4>

                                        <p>
                                            Become part of a structured home services
                                            ecosystem designed to create a more
                                            transparent and dependable experience
                                            for customers and professionals.
                                        </p>

                                    </div>

                                </div>

                            </div>

                        </div>


                        {/* Digital Growth */}
                        <div className="col-lg-6">

                            <div className="glass-grid-box">

                                <div className="grid-box-inner">

                                    <div className="grid-square-icon-wrapper accent-teal">
                                        <FaLaptopCode className="grid-panel-icon" />
                                    </div>

                                    <div className="grid-box-text-block">

                                        <h4>Digital Tools for Your Business</h4>

                                        <p>
                                            Move beyond traditional ways of managing
                                            your service business with digital tools
                                            that help you manage bookings and
                                            customer interactions more efficiently.
                                        </p>

                                    </div>

                                </div>

                            </div>

                        </div>


                        {/* Professional Growth */}
                        <div className="col-lg-6">

                            <div className="glass-grid-box">

                                <div className="grid-box-inner">

                                    <div className="grid-square-icon-wrapper accent-blue">
                                        <FaHandshake className="grid-panel-icon" />
                                    </div>

                                    <div className="grid-box-text-block">

                                        <h4>Grow Your Professional Network</h4>

                                        <p>
                                            Build stronger connections within the
                                            home services ecosystem and create
                                            opportunities for long-term professional
                                            growth.
                                        </p>

                                    </div>

                                </div>

                            </div>

                        </div>


                        {/* Customer Trust */}
                        <div className="col-lg-6">

                            <div className="glass-grid-box">

                                <div className="grid-box-inner">

                                    <div className="grid-square-icon-wrapper accent-yellow">
                                        <FaHeart className="grid-panel-icon" />
                                    </div>

                                    <div className="grid-box-text-block">

                                        <h4>Build Customer Trust</h4>

                                        <p>
                                            Deliver quality service, maintain a strong
                                            professional presence, and build lasting
                                            relationships with customers through the
                                            Fixovera platform.
                                        </p>

                                    </div>

                                </div>

                            </div>

                        </div>


                    </div>

                </div>

            </section>


            {/* 4. Partner CTA Section */}
            <section className="PartnerBenefits-details-section">

                <div className="container">

                    <div className="row justify-content-center text-center">

                        <div className="col-lg-9">

                            <p className="info-small-text">
                                READY TO GROW?
                            </p>

                            <h2 className="PartnerBenefits-section-heading">
                                Turn Your Skills Into More Opportunities
                            </h2>

                            <div className="zigzag-divider mb-4 mx-auto"></div>

                            <p className="PartnerBenefits-body-text">
                                Join Fixovera as a service partner and connect with
                                customers who need your expertise. Focus on delivering
                                great service while Fixovera helps bring your services
                                to more customers.
                            </p>

                            <p className="PartnerBenefits-body-text highlighted-paragraph">
                                From receiving bookings to managing your service
                                requests, Fixovera gives you the tools and platform
                                to build a stronger digital presence for your business.
                            </p>

                        </div>

                    </div>

                </div>

            </section>


            {/* Download App Section */}
            <DownloadApp />


            {/* Global Bottom Components */}
            <Newsletter />
            <Footer />

        </div>
    );
}

export default PartnerBenefits;